/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, Dispatch, SetStateAction } from "react";
import { CommonHeader } from "components/Common/CommonHeader";
import { Home } from "pages/Home";
import { Tasks } from "pages/Tasks";
import { Multiple } from "pages/Multiple";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProjectInfo, userContext, useUserContext } from "context/UserContext";
import { Camera } from "pages/Camera";
import { UserGuide } from "pages/UserGuide";
import { About } from "pages/About";
import { Const } from "const";

export interface RouterProps {
  jobsite: ProjectInfo;
  setJobsite: Dispatch<SetStateAction<ProjectInfo | undefined>>;
}

export const Router: FC<RouterProps> = ({ jobsite, setJobsite }) => {
  const ctx = useUserContext();
  ctx.jobsite = jobsite;

  return (
    <>
      <userContext.Provider value={ctx}>
        <CommonHeader setJobsite={setJobsite} />
        <Routes>
          <Route
            path={Const.path.root}
            element={<Navigate replace to={Const.path.map} />}
          />
          <Route path={Const.path.map} element={<Home />} />
          <Route path={Const.path.tasklist} element={<Tasks />} />
          <Route path={Const.path.camera} element={<Camera />} />
          <Route path={Const.path.userguide} element={<UserGuide />} />
          <Route path={Const.path.about} element={<About />} />
          <Route
            path={Const.path.general}
            element={<Navigate replace to={Const.path.root} />}
          />
          <Route path={Const.path.multiple} element={<Multiple />} />
        </Routes>
      </userContext.Provider>
    </>
  );
};
